module.exports = __webpack_public_path__ + "static/img/child_porn_1_sc.3f25936f.png";